import PropTypes from 'prop-types';
import React from 'react';
import BasicDownload from '../core/BasicDownload';
import ExportAndDownload from '../core/ExportAndDownload';

class OntologyExport extends React.Component {

    render() {

        return (
            <ExportAndDownload>
                <BasicDownload
                    resource={this.props.id}
                    graph={this.props.graph}
                    exportName="ontologyexport"
                    message="Export all classes and properties in the ontology." />
            </ExportAndDownload>
        );
    }
}

OntologyExport.propTypes = {
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired
};

export default OntologyExport;